import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import { Host } from '../../App';

function Edit_Part_layout({ part_layout }) {

  const [data, setData] = useState([
    { Part_No: "", Part_internalNo: "", Part_Description: "", Customer: "", Type: "" },
  ]);
  var User = JSON.parse(window.localStorage.getItem("Name"));
  const [isLoading, setIsLoading] = useState(false);



  const [formData, setFormData] = useState({
    Part_Name: "",
    Sub_Parts: "",
    Customer: "",
    Size: "",
    Qty_Per_Sheet: "",
    Timing_min: "",
    WIP_Dependency: "",
    Category: "",
    Required_Pcs: "",
    Sheet_Item_No: "",
    Part_No: "",
    User
  });
  const submitPart = async () => {
    setIsLoading(true);
    try {
      const response = await Axios.post(`https://` + Host + `/woodshop/part_layout/add-part`, { formData: formData });
      alert('Part added successfully');
    } catch (error) {
      console.error('Error adding part:', error);
      alert('Failed to add part');
    }
    window.location.reload(false);
  };

  return (
    <div>
      <div className="Container">
        <br />
        <div>
          <h2 style={{ padding: 10 }}>Add New Part Layout</h2>
          <br />
          <div className="add_section">
            <center>
              <div className="row" id="Part_dataset_add">
                <table>
                  <tbody>
                    <tr>
                      <td style={{ padding: 10 }}>
                        <label>Part No</label>
                        <input
                          type="text"
                          name="Part_No"
                          list="Part_No"
                          className="form-control form-rounded"
                          onChange={(e) => setFormData({ ...formData, Part_No: e.target.value })}
                        />
                        <datalist id="Part_No">
                          <option></option>
                          {[...new Set(part_layout.map(x => x.Part_No))].map((Part_No, index) => (
                            <option key={index} value={Part_No} />
                          ))}
                        </datalist>
                      </td>
                      <td style={{ padding: 10 }}>
                        <label>Sub Parts</label>
                        <input
                          type="text"
                          name="Sub_Parts"
                          className="form-control form-rounded"
                          onChange={(e) => setFormData({ ...formData, Sub_Parts: e.target.value })}
                        />
                      </td>
                      <td style={{ padding: 10 }}>
                        <label>Customer</label>
                        <input
                          type="text"
                          name="Customer"
                          list="Customer"
                          className="form-control form-rounded"
                          onChange={(e) => setFormData({ ...formData, Customer: e.target.value })} />
                        <datalist id="Customer">
                          <option></option>
                          {[...new Set(part_layout.map(x => x.Customer))].map((customer, index) => (
                            <option key={index} value={customer} />
                          ))}
                        </datalist>

                      </td>
                      <td style={{ padding: 10 }}>
                        <label>Size</label>
                        <input
                          type="text"
                          name="Size"
                          list="Size"
                          className="form-control form-rounded"
                          onChange={(e) => setFormData({ ...formData, Size: e.target.value })}
                        />
                        <datalist id="Size">
                          <option></option>
                          {[...new Set(part_layout.map(x => x.Size))].map((Size, index) => (
                            <option key={index} value={Size} />
                          ))}
                        </datalist>
                      </td>
                      <td style={{ padding: 10 }}>
                        <label>Qty Per Sheet</label>
                        <input
                          type="number"
                          name="Qty_Per_Sheet"
                          className="form-control form-rounded"
                          onChange={(e) => setFormData({ ...formData, Qty_Per_Sheet: e.target.value })}
                        />
                      </td>
                      <td style={{ padding: 10 }}>
                        <label>Timing (min)</label>
                        <input
                          type="number"
                          name="Timing_min"
                          className="form-control form-rounded"
                          onChange={(e) => setFormData({ ...formData, Timing_min: e.target.value })}
                        />
                      </td>
                    </tr>
                    <tr>

                      <td style={{ padding: 10 }}>
                        <label>WIP Dependency</label>
                        <input
                          type="text"
                          name="WIP_Dependency"
                          list="WIP_Dependency"
                          className="form-control form-rounded"
                          onChange={(e) => setFormData({ ...formData, WIP_Dependency: e.target.value })}
                        />
                        <datalist id="Customer">
                          <option></option>
                          {[...new Set(part_layout.map(x => x.WIP_Dependency))].map((WIP_Dependency, index) => (
                            <option key={index} value={WIP_Dependency} />
                          ))}
                        </datalist>
                      </td>
                      <td style={{ padding: 10 }}>
                        <label>Category</label>
                        <input
                          type="text"
                          name="Category"
                          list="Category"
                          className="form-control form-rounded"
                          onChange={(e) => setFormData({ ...formData, Category: e.target.value })}
                        />
                        <datalist id="Category">
                          <option></option>
                          {[...new Set(part_layout.map(x => x.Category))].map((Category, index) => (
                            <option key={index} value={Category} />
                          ))}
                        </datalist>
                      </td>
                      <td style={{ padding: 10 }}>
                        <label>Required Pcs</label>
                        <input
                          type="number"
                          name="Required_Pcs"
                          className="form-control form-rounded"
                          onChange={(e) => setFormData({ ...formData, Required_Pcs: e.target.value })}
                        />
                      </td>
                      <td style={{ padding: 10 }}>
                        <label>Sheet Item No</label>
                        <input
                          type="text"
                          name="Sheet_Item_No"
                          list="Sheet_Item_No"
                          className="form-control form-rounded"
                          onChange={(e) => setFormData({ ...formData, Sheet_Item_No: e.target.value })}
                        />
                        <datalist id="Sheet_Item_No">
                          <option></option>
                          {[...new Set(part_layout.map(x => x.Sheet_Item_No))].map((Sheet_Item_No, index) => (
                            <option key={index} value={Sheet_Item_No} />
                          ))}
                        </datalist>
                      </td>
                      <td style={{ padding: 10 }}>
                        <label>Part Name</label>
                        <input
                          type="text"
                          name="Part_Name"
                          list="Part_Name"
                          className="form-control form-rounded"
                          onChange={(e) => setFormData({ ...formData, Part_Name: e.target.value })}
                        />
                        <datalist id="Part_Name">
                          <option></option>
                          {[...new Set(part_layout.map(x => x.Part_Name))].map((Part_Name, index) => (
                            <option key={index} value={Part_Name} />
                          ))}
                        </datalist>
                      </td>
                      <td style={{ padding: 10 }}>
                        <label>  .</label>
                        <input
                          type="button"
                          className="btn btn-success"
                          value="Submit"
                          onClick={submitPart}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <div>
                </div>
              </div>
            </center>
          </div>
        </div>

        {isLoading ?
          <div className='overlay'>
            <div class="text-center">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div> : null}
      </div>

    </div>
  )
}

export default Edit_Part_layout